import { render, staticRenderFns } from "./BuildingCard.vue?vue&type=template&id=5d2c0e06&scoped=true&"
import script from "./BuildingCard.vue?vue&type=script&lang=js&"
export * from "./BuildingCard.vue?vue&type=script&lang=js&"
import style0 from "./BuildingCard.vue?vue&type=style&index=0&id=5d2c0e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c0e06",
  null
  
)

export default component.exports